import React from "react";
import { useIntl } from "react-intl";

import ConfirmationPopup from "@components/ConfirmationPopup";
import DataTable from "@components/DataTableV2/DataTable";
import Div from "@components/Div";

import { useOtherCasesTab } from "./OtherCasesTab.hooks";

const OtherCasesTab = () => {
  const { formatMessage, messages } = useIntl();
  const {
    otherCaseToDelete,
    otherCasesConfig,
    handleConfirmDeleteOtherCase,
    handleCloseDeleteOtherCaseDialog,
  } = useOtherCasesTab();

  return (
    <Div display="flex" flexDirection="column" gridGap={4}>
      {otherCaseToDelete !== null && (
        <ConfirmationPopup
          title={messages.label_delete_crime}
          description={`${formatMessage({ id: "label_delete_crime" })} ${otherCaseToDelete?.crime_name}`}
          onAcceptClick={handleConfirmDeleteOtherCase}
          onCancelClick={handleCloseDeleteOtherCaseDialog}
        />
      )}

      <DataTable config={otherCasesConfig} />
    </Div>
  );
};

export default OtherCasesTab;
